// auto-generated by Typewriter template _models.tst from PortCall.Models\Billing\QuickBooks\QuickBooksInventoryItemTracking.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';


// QuickBooksInventoryItemTrackingData is the class that QuickBooksInventoryItemTracking serializes to/from
export interface QuickBooksInventoryItemTrackingData {
	
	
    Account : string | null;
    Name : string | null;
}

// QuickBooksInventoryItemTrackingOptions is the class which may be passed to the QuickBooksInventoryItemTracking constructor to define optional initial data values
export interface QuickBooksInventoryItemTrackingOptions {
	
	
    Account? : string | null;
    Name? : string | null;
}

export class QuickBooksInventoryItemTracking {
	
	
    public Account : DataSignal<string | null>;
    public Name : DataSignal<string | null>;

    constructor();
    constructor(data : QuickBooksInventoryItemTrackingOptions);
    constructor(data: QuickBooksInventoryItemTrackingOptions | null = null) {
	    
	    
        this.Account = jsonableObservable(S.value<string | null>(data && data.Account !== undefined ? data.Account : null));
        this.Name = jsonableObservable(S.value<string | null>(data && data.Name !== undefined ? data.Name : null));
    }

    static key(obj : QuickBooksInventoryItemTracking) {
        return ;
    }
    
    static dataKey(obj : QuickBooksInventoryItemTrackingOptions) {
        return ;
    }

    static update(obj : QuickBooksInventoryItemTracking, data : QuickBooksInventoryItemTrackingOptions) {
        S.freeze(() => {
	        
	        
            if (data.Account !== undefined) obj.Account(data.Account);
            if (data.Name !== undefined) obj.Name(data.Name);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/QuickBooksInventoryItemTracking.ts